 
  <div
    gdArea="header"
    class="primary-background-colour"></div>

  <div
    gdArea="header"
  >
    <!-- Fullscreen header. -->
    <abl-header fxShow>
      <div
      fxLayoutAlign="center center"
      class="logo-container-background-colour"
    >
      <img 
        fxFlex="20"
        [src]="tenantService.getImagePath('logo-onboarding')"
        [alt]="tenantService.getTenant"
      >
    </div>
    </abl-header>
    <mat-divider></mat-divider>

    <div fxLayout fxLayoutGap="40px" style="margin-top: 40px;">
  <div fxFlex="40%" fxLayoutAlign="center center">
    <img
      [src]="tenantService.getImagePath('complete-screen-smartphone')"
      alt="smartphone app"
      class="smartphone-image"
    />
  </div>
  <div fxFlex="60%" fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="column" fxLayoutGap="5px">
      <span
        ><strong>Get the app</strong></span
      >
      <span
        >We have sent you a link to download the app or you can download it right now.</span>
      <span></span>
      <div fxLayoutAlign="flex-start" fxLayoutGap="80px" fxLayout.lt-md="column">
        <a [href]="appStoreUrl" class="app-store-image" target="_blank">
          <img src="assets/apple-app-store.svg" alt="Apple app store" />
        </a>
        <a [href]="playStoreUrl" class="app-store-image" target="_blank">
          <img src="assets/android-app-store.svg" alt="Android app store" />
        </a>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="column" fxLayoutGap="5px">
      <span
        ><strong>Use the app:</strong></span
      >
      <span>1) Sign into the app using your email.</span>
      <span>2) Photograph your passport or driving licence.</span>
      <span>3) Take a selfie to validate your identity.</span>
      <span>4) Photograph a proof of address.</span>
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="column" fxLayoutGap="5px">
      <span>If you don't want to use the app to verify your identity, you can do this by sending us copies by email or in the post.</span>
      <br />
      <a [href]="mobileFaqLink" target="_blank"> Click here for instructions. </a>
      <span *ngIf="env === envEnum">Please note this may increase the time for your account to be activated.</span>
    </div>
  </div>
</div>

  </div>

 